import React, { useState, useEffect } from 'react';
import { ViewStockPopup } from './Component/ViewStockPopup';
import './styles.scss';
interface Props {
  content: string;
}
export const ViewStock: React.FC<Props> = () => {
  return <ViewStockPopup content="" />;
};
